<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='add'||modal.type=='up'" ref="refForm"
				:model="modalInfo" :label-width="90">
				<Row v-show='false' :gutter="24" style="margin-bottom: 10px;">
					<Col span=6>
					<FormItem :label="$tt('事件Id')" prop="Name">
						<Input :disabled="modal.Id" v-model="modalInfo.Id" :placeholder="$tt('事件Id')"></Input>
					</FormItem>
					</Col>
					<Col span=6>
					<FormItem :label="$tt('场站ID')" prop="StationId">
						<Input :disabled="modal.canInput" v-model="modalInfo.StationId" :placeholder="$tt('场站ID')"></Input>
					</FormItem>
					</Col>
					<Col span=6>
					<FormItem :label="$tt('事件代码')" prop="EventCode">
						<Input :disabled="modal.canInput" v-model="modalInfo.EventCode" :placeholder="$tt('事件代码')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem :label="$tt('场站名字')" prop="StationId">
						<Select filterable :disabled="modal.canInput" :placeholder="$tt('站点列表')" v-model="modalInfo.StationId">
							<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('事件描述')" prop="EventCode">
						<Select filterable :disabled="modal.canInput" :placeholder="$tt('事件描述')" v-model="modalInfo.EventCode">
							<Option v-bind:key="item.Id" v-for="(item) in EventList" :value="item.Id">{{item.Name}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem :label="$tt('时间')" prop="EventTime">
						<DatePicker :disabled="modal.canInput" type="datetime" v-model="modalInfo.EventTime"
							:placeholder="$tt('时间')"></DatePicker>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('备注')" prop="Remark">
						<Input :disabled="modal.canInput" v-model="modalInfo.Remark" :placeholder="$tt('备注')"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{$tt('取消')}}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{$tt('添加')}}</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{$tt('取消')}}</Button>
				<Button type="success" @click="modalOk('up')" size="large">{{$tt('修改')}}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			return {
				modal: {
					Title: this.$tt('事件添加'),
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				modalInfo: {
					// 事件Id
					// 场站ID
					// 场站名字
					// 事件代码
					// 事件描述
					// 时间
					// 备注
					Id: 0,
					StationId: "",
					StationName: "",
					EventCode: "",
					EventDesc: "",
					EventTime: "",
					Remark: ""
				},
				/******分割线********/
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				//校验字段
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					StationId: [{
						required: true,
						message: this.$tt('控件名称'),
						trigger: 'change',
						type: 'number'
					}],
					EventCode: [{
						required: true,
						message: this.$tt('显示名称'),
						trigger: 'change',
						type: 'number'
					}],
				},
			};
		},

		methods: {
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = this.$tt('事件添加');
					_this.modal.type = "add";
					_this.$refs.refForm.resetFields()
				} else if (type == "up") {
					_this.modal.Title = this.$tt('事件修改');
					_this.modal.type = "up";
					_this.modalInfo = Object.assert({}, ...params)
				}
				_this.modal.ifShow = true
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			//添加
			addAndUp: function(type) {
				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("事件" + type + "----" + valid)
					if (valid) {
						let parms = {
							"StationId": this.modalInfo.StationId,
							"EventCode": this.modalInfo.EventCode,
							"EventTime": dateFormat.formatDate(this.modalInfo.EventTime, 'yyyy-MM-dd'),
							"Remark": this.modalInfo.Remark
						}
						_this.$axios.post(webapi.base_api_url + "/Archives/AddEventInfo", parms, {}).then(
							res => {
								console.log("新增事件")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success(this.$tt('新增事件成功'));
									_this.$emit('handleSubmit');
									_this.modalOk("cancle")
								} else {
									this.$Message.success(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},
			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')
				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$tt('格式错误'),
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$tt('图片太大'),
					desc: '文件' + file.name + this.$tt(' 图片太大请选择小于 2M.')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				EventList: 'EventList'
			})
		}
	}
</script>

<style>
</style>
